<template>
  <md-button class="menu-button" :class="{vertical, shadow, centered, disabled}" :disabled="disabled" v-bind="$attrs" @click="click">
    <md-progress-spinner
      v-show="icon && loading"
      class="spinner"
      :class="{visible: loading, hidden: !loading}"
      :md-diameter="20"
      :md-stroke="2"
      md-mode="indeterminate"
    />
    <md-icon v-show="icon && !loading" class="icon">{{ icon }}</md-icon>
    <span v-if="label">{{ label }}</span>
    <md-icon v-if="closeIcon" class="close-icon">{{ closeIcon }}</md-icon>      
    <div v-if="badge">
      <md-badge :md-content="badge" />
    </div>
  </md-button>
</template>

<script>
export default {
  name: 'menu-button',
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    closeIcon: {
      type: String,
      default: null,
    },
    badge: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click(...args) {
      this.$emit('click', ...args);
    },
  },
};
</script>

<style scoped>
.menu-button {
  height: 60px;
  background-color: #303243;
  color: white !important;
  border-radius: 0;
  margin: 0;
  text-transform: uppercase;
  font-size: 18px;
  text-align: left !important;
  white-space: normal;
}

.menu-button.shadow {
  box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.75);
}

.menu-button .md-icon {
  color: #ffffff !important;
}

.close-icon {
  padding-left: 8px;
}

.menu-button span {
  vertical-align: middle;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, .25)
}

.spinner {
  margin: 8px 0;
}

.spinner.hidden {
  height: 0;
  display: none;
}

.md-button >>> .md-button-content {
  width: 100%;
  position: relative;
}

.md-badge {
  position: absolute;
  transform: translate(10px, -35px);
}
</style>

<style>
.menu-button.vertical .md-button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-button .md-progress-spinner-circle {
  stroke: #fff !important;
}

.menu-button .md-progress-spinner {
  transition: none !important;
}

.menu-button > .md-ripple {
  justify-content: left;
}

.menu-button.centered > .md-ripple {
  justify-content: center;
}
</style>